//@flow
import React from "react"
import {observer} from "mobx-react"
import {FormattedMessage} from "react-intl"
import {Dialog, DialogContent, DialogTitle, DialogActions, Grid} from "@material-ui/core"
import XsButton from "../../../../../global/ui/xsButton/xsButton"
import InvitePatientDialogStore from "../../../stores/InvitePatientDialogStore"

@observer
export default class InvitePatientDialog extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		return (
			<Dialog
				id="xsInvitePatient"
				open={InvitePatientDialogStore.isOpen}
				onClose={() => InvitePatientDialogStore.close()}
				onEscapeKeyDown={() => InvitePatientDialogStore.close()}
				disableBackdropClick={true}
				maxWidth="sm"
				className="xs-base-dialog"
			>
				<DialogTitle className="xs-base">
					<div className="xs-header">
						<div className="xs-header-icon">
							<i className="fal fa-envelope fa-2x"></i>
						</div>
						<div className="xs-header-title">
							<FormattedMessage id="Common.label.invite" />
						</div>
					</div>
				</DialogTitle>
				<DialogContent className="xs-content">
					<Grid container justify="center">
						<Grid item>
							<XsButton
								className="xs-primary xs-outline"
								icon={<i className="fal fa-envelope"></i>}
								text={<FormattedMessage id="Common.label.sendInvitation" />}
								onClick={() => InvitePatientDialogStore.sendInvitation()}
							/>
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions className="xs-footer">
					<XsButton
						className="xs-default xs-outline"
						icon={<i className="fal fa-times"></i>}
						text={<FormattedMessage id="Common.form.close" />}
						onClick={() => InvitePatientDialogStore.close()}
					/>
				</DialogActions>
			</Dialog>
		)
	}
}
